<template>
  <div class="prompt">
  <div class="bank-card">
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close">
      </div>
      <div class="header-card-text">
        <h3>Add Bank</h3>
        <p>Add your bank details for cashout on maturity of investments.</p>
      </div>
    </div>

   <div class="authCard m-auto">
      <form class="auth-form" @submit="addBank">
        <div class="form-group">
          <label>Account Number</label>
          <input type="number" inputmode="decimal" v-model="accountNumber" class="form-control"
          required>
        </div>
        <p v-if="error" class="error-msg">Account Name Unresolved</p>

        <div class="form-group">
          <label>Bank</label>
          <select v-model="bankCode" class="form-control" @change="verifyBank()">
            <option value="">-- Select bank --</option>
            <option v-for="bank, index in banks" :key="index" :value="bank.bank_code">
              {{ bank.bank_name }}</option>
          </select>
        </div>

        <div class="form-group">
          <label class="text-left">Account Name</label>
          <input type="text" v-model="accountName" class="form-control" required disabled>
        </div>
        <vue-loaders-ball-spin-fade-loader scale=".5" color="red" v-if="verifybank">
          </vue-loaders-ball-spin-fade-loader>
        <p v-if="error1" class="error-msg">{{ errormsg }}</p>

        <div>
          <button class="btn primary-btn btn-block" :disabled="isDisabled">
          <span v-if="!loading">ADD</span>
          <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
          </vue-loaders-ball-spin-fade-loader>
          </button>
        </div>
      </form>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: {},
      bank: {},
      accountNumber: '',
      bankCode: '',
      bankName: '',
      accountName: '',
      error: false,
      error1: false,
      errormsg: '',
      loading: false,
      verifybank: false,
    };
  },
  mounted() {
    this.getBank();
    this.getBanks();
  },
  computed: {
    isDisabled() {
      if (!this.accountName) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async getBank() {
      const url = `${this.$baseUrl}/user/bank`;
      const res = await this.$http({ url, method: 'GET' });
      this.bank = res.data.bank;
      this.$store.commit('set_bank', res.data.bank);
    },
    async getBanks() {
      const url = `${this.$baseUrl}/admin/banks`;
      const res = await this.$http({ url, method: 'GET' });
      this.banks = res.data.banks;
    },

    async verifyBank() {
      this.verifybank = true;
      const url = `${this.$baseUrl}/admin/bank/verify`;
      this.error = false;
      const data = {
        code: this.bankCode,
        accountNumber: this.accountNumber,
      };
      try {
        const res = await this.$http({ url, data, method: 'POST' });
        this.accountName = res.data.data.account_name;
        this.verifybank = false;
      } catch (error) {
        this.verifybank = false;
        this.error = true;
        this.accountName = '';
      }
    },

    async addBank(e) {
      e.preventDefault();
      this.loading = true;
      this.error1 = false;
      // Get bank name
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.banks.length; i++) {
        const element = this.banks[i];
        if (element.bank_code === this.bankCode) {
          this.bankName = element.bank_name;
        }
      }
      const url = `${this.$baseUrl}/bank/add`;
      const data = {
        code: this.bankCode,
        accountNumber: this.accountNumber,
        accountName: this.accountName,
        bankName: this.bankName,
      };
      try {
        await this.$http({ url, data, method: 'POST' });
        await this.getBank();
        this.loading = false;
        this.$toast.open('Bank Account added', {
          duration: 2500,
          type: 'success',
          dismissible: true,
        });
        this.$emit('close');
      } catch (error) {
        this.error1 = true;
        this.loading = false;
        this.errormsg = error.response.data.message;
      }
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
  .form-group{
    text-align: left !important;
  }
  .bank-card{
    margin-top: 15%;
    background-color: #FFF;
  }
  .authCard{
    padding-top: 0;
  }
  .header-card{
    padding-bottom: 0;
  }
  .absolute{
    position: absolute;
    top: 0;
    background-color: #F9F9F9;
    z-index: 2;
    width: 100%;
    height: 100%;
  }
</style>
